import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Helpers } from '../../core';
import useCartState, { useCartActions } from '../../hooks/useCartState';

import ConfigureAmount from './configure-amount';
import ConfigureMessage from './configure-message';

import './gift-card.less';

export const isGiftCard = product => {
    if (!product) {
        return false;
    }
    return ['VGC', 'PGC'].includes(product.product_type);
};

const GiftCard = ({ product, Amount, Message }) => {
    const location = useLocation();
    const { viewConfig } = useCartActions();
    const { cartId, cartInfo } = useCartState();
    const { items } = cartInfo || {};
    const { search } = location || {};
    const params = Helpers.getSearch(search);
    const { editGC, editGcOrderItemId } = params || {};
    const [editGiftCard, setEditGiftCard] = useState(null);
    const [configCatentryId, setConfigCatentryId] = useState(null);
    if (!isGiftCard(product)) {
        return null;
    }
    useEffect(() => {
        if (!editGC || !editGcOrderItemId || !cartId) {
            return;
        }
        viewConfig(editGcOrderItemId).then(resp => {
            const { viewEditConfig } = resp || {};
            const { 'From:': fromName, 'To:': toName } = viewEditConfig || {};
            if (!fromName || !toName) {
                return;
            }
            const cartItem = items.find(({ id }) => id === editGcOrderItemId);
            const { ceId } = cartItem || {};
            setEditGiftCard({ fromName, toName, editGC: 'Y', editGcOrderItem: editGcOrderItemId, isGC: true });
            setConfigCatentryId(ceId);
        });
    }, [cartId, editGC, editGcOrderItemId]);

    return (
        <>
            <ConfigureAmount product={product} Amount={Amount} selectDefault editConfigId={configCatentryId} />
            <ConfigureMessage product={product} Message={Message} editMessage={editGiftCard} />
        </>
    );
};

export default GiftCard;
